// 匿名可访问的展示页：仅卡片渲染页。
// 其余页面（计算器/Echarts 组件/低代码管理页/设计器/流式卡片）均要求登录。
export const PUBLIC_PATHS = [
  '/portal/micro-component-card/render'
]
